import { EventSlot } from "../../../library-js/events/EventSlot";
import { Overlay } from "./Overlay";

export class OverlayOptions
{
  isClosable:boolean = true;
  readonly onClose:EventSlot<any> = new EventSlot();

  static getDefault()
  {
    let options = new OverlayOptions();
    options.isClosable = true;
    return options;
  }
 
}